import type { WithStyles } from '@material-ui/core/styles'
import { createStyles, withStyles } from '@material-ui/core/styles'
import { Typography } from '@paintscout/ui'
import classnames from 'classnames'
import React from 'react'

export interface PageTitleProps extends WithStyles<typeof styles> {
  children?: React.ReactNode
  title?: React.ReactNode
  subtitle?: React.ReactNode
  dense?: boolean
}

const styles = () =>
  createStyles({
    root: {},
    pageTitle: {
      textTransform: 'capitalize'
    },

    pageSubtitle: {
      textTransform: 'capitalize'
    }
  })

const PageTitle = (props: PageTitleProps) => {
  const { classes } = props
  return (
    <div className={props.classes.root}>
      <Typography
        className={classnames('page-title', classes.pageTitle)}
        variant={'h1'}
        component="h1"
        color={'inherit'}
        noWrap
      >
        {props.title}
      </Typography>
      {props.subtitle && (
        <Typography className={classnames('page-subtitle', classes.pageSubtitle)} variant={'subtitle1'} noWrap>
          {props.subtitle}
        </Typography>
      )}
    </div>
  )
}

export default withStyles(styles)(PageTitle)
